// ADD PRODUCT TO CART
export const ADD_TO_CART = (state, { product, quantity }) => {
  let inCart = state.cart.find((item) => {
    return item.product.id == product.id;
  });
  product.selected = true;

  // INCREASE QUANTITY IF ITEM IS ALREDY IN CART
  if (inCart) {
    inCart.quantity += quantity;
    inCart.product.selected = true;
    return;
  }

  // STORE ITEMS ADDED IN SESSION STORAGE
  let cartItem = {
    product,
    quantity,
  };
  let products = sessionStorage.getItem("cart")
    ? JSON.parse(sessionStorage.getItem("cart"))
    : [];

  let cart = [...products, cartItem];
  sessionStorage.setItem("cart", JSON.stringify(cart));

  state.cart.push({
    product,
    quantity,
  });
};

// REMOVE PRODUCT FROM CART
export const REMOVE_PRODUCT_FROM_CART = (state, product) => {
  product.selected = false;
  state.cart = state.cart.filter((item) => {
    return item.product.id !== product.id;
  });

  // REMOVE PRODUCT FROM SESSION STORAGE
  let cart = JSON.parse(sessionStorage.getItem("cart"));
  cart.forEach((item, index) => {
    if (item.product.id == product.id) {
      cart.splice(index, 1);
    }
    sessionStorage.setItem("cart", JSON.stringify(cart));
  });
};

// CLEAR ALL ITEMS IN CART
export const CLEAR_CART = (state) => {
  let arrays = state.allProducts.length;

  // CLEAR SESSION STORAGE
  let cart = JSON.parse(sessionStorage.getItem("cart"));
  sessionStorage.clear();

  state.checkoutInfo = false;
  state.checkout = false;
  state.paystackPayment = false;
  state.cart = [];
  while (arrays--) {
    state.allProducts[arrays].selected = false;
  }

  while (cart.firstChild) {
    cart.removeChild(cart.firstChild);
  }
  state.checkout = false;
};

// SET CHECKOUT TO TRUE
export const SET_CHECKOUT = (state) => {
  state.checkout = true;
};

// STORE RODUCTS FROM API TO ALLPRODUCT STATE
export const GET_ALL_PRODUCTS = (state, allproduct) => {
  state.allProducts = allproduct;
};

// GET PRODUCTS BY SEARCH
export const GET_SEARCH_RESULT = (state, productSearch) => {
  var keyWordToSearch = productSearch.toLowerCase();
  // CHECK PRODUCT BY CATEGORY
  let category = state.allProducts.filter((product) => {
    return product.category.toLowerCase().includes(keyWordToSearch);
  });

  // CHECK PRODUCT BY NAME
  let productName = state.allProducts.filter((product) => {
    return product.name.toLowerCase().includes(keyWordToSearch);
  });

  // CHECK PRODUCTS BY DESCRIPTION
  let productDescription = state.allProducts.filter((product) => {
    return !product.description.toLowerCase().includes(keyWordToSearch);
  });

  // STORE SEARCH BY CATEGORY RESULT IN STATE IF THERE'S ANY RESULT
  if (category.length > 0) {
    state.searchs = category;
    return;
  }

  // STORE SEARCH BY NAME RESULT IN STATE IF THERE'S ANY RESULT
  if (productName.length > 0) {
    state.searchs = productName;
    return;
  }

  // STORE SEARCH BY DESCRIPTION RESULT IN STATE IF THERE'S ANY RESULT
  if (productDescription.length > 0) {
    state.searchs = productDescription;
    return;
  }

  // IF THERE IS NO RESULT FOUND, SET SEARCH STATE TO EMPTY ARRAY
  if (
    productName.length <= 0 ||
    category.length <= 0 ||
    productDescription.length <= 0
  ) {
    state.searchs = [];
    return;
  }
};

// SHOW SEARCH INPUT
export const SHOW_SEARCH = (state) => {
  state.showSearch = true;
};

// HIDE SEARCH INPUT
export const HIDE_SEARCH = (state) => {
  state.showSearch = false;
};
